import React from 'react';
import { Layout, Typography, Space, Image, Row, Col, Divider } from 'antd';
import { SmileOutlined, TeamOutlined, PayCircleOutlined, FileDoneOutlined } from '@ant-design/icons';
import O2MLogo from '@app/assets/images/O2M-Logo.png';

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

const HomePage = () => {
  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>      
      <Content style={{ padding: '40px 24px' }}>
        <Row justify="center">
          <Col xs={24} md={22} lg={20} xl={18}>
            <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
              <Image
                alt="One2Many Logo"
                src={O2MLogo}
                preview={false}
                style={{ 
                  maxHeight: '110px',
                  objectFit: 'contain',
                  marginBottom: '0px'
                }}
              />
              
              {/* <Divider style={{ borderColor: '#e8e8e8' }} /> */}
              
              <Title level={2} style={{ marginBottom: '5px' }}>
                Bienvenido al Sistema de Nómina
              </Title>
              
              {/* <Text type="secondary" style={{ 
                fontSize: '16px', 
                maxWidth: '600px',
                display: 'inline-block',
                marginBottom: '24px'
              }}>
                Gestiona fácilmente la nómina de tu empresa con nuestras herramientas integradas y simplifica tus procesos administrativos.
              </Text> */}
              
              {/* <SmileOutlined style={{ 
                fontSize: '48px', 
                color: '#1890ff',
                margin: '20px 0 40px'
              }} /> */}
              
              {/* <Row gutter={[24, 24]} style={{ marginTop: '10px' }}>
                <Col xs={24} sm={12} md={8}>
                  <div style={{ padding: '16px', background: '#fff', borderRadius: '8px', height: '100%' }}>
                    <TeamOutlined style={{ fontSize: '32px', color: '#13c2c2' }} />
                    <Title level={4} style={{ marginTop: '16px' }}>Empleados</Title>
                    <Text type="secondary">Gestiona tu personal</Text>
                  </div>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <div style={{ padding: '16px', background: '#fff', borderRadius: '8px', height: '100%' }}>
                    <PayCircleOutlined style={{ fontSize: '32px', color: '#722ed1' }} />
                    <Title level={4} style={{ marginTop: '16px' }}>Nóminas</Title>
                    <Text type="secondary">Calcula y procesa pagos</Text>
                  </div>
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <div style={{ padding: '16px', background: '#fff', borderRadius: '8px', height: '100%' }}>
                    <FileDoneOutlined style={{ fontSize: '32px', color: '#52c41a' }} />
                    <Title level={4} style={{ marginTop: '16px' }}>Reportes</Title>
                    <Text type="secondary">Genera informes detallados</Text>
                  </div>
                </Col>
              </Row> */}
            </Space>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default HomePage;